export default __webpack_public_path__ + "static/media/hermit1.fdbdddf3.jpeg";